const acDomain = 'https://180815.origintheatrical.com.au'
export default acDomain
